import React from 'react';

const JobDetailPanelSkeleton: React.FC = () => {
  return (
    <div className="job-detail-panel">
      <div className="card h-100">
        <div className="card-body" style={{ maxWidth: '800px', margin: '0 auto' }}>
          {/* ヘッダー部分のスケルトン */}
          <div className="mb-4">
            <div 
              className="skeleton-line" 
              style={{ 
                height: '2rem', 
                width: '100%', 
                marginBottom: '1rem',
                borderRadius: '4px'
              }}
            ></div>
            <div 
              className="skeleton-line" 
              style={{ 
                height: '1.5rem', 
                width: '100%', 
                marginBottom: '0.5rem',
                borderRadius: '4px'
              }}
            ></div>
          </div>

          {/* メタ情報のスケルトン */}
          <div className="mb-4">
            <div className="d-flex gap-2 mb-3">
              <div 
                className="skeleton-badge" 
                style={{ 
                  height: '2rem', 
                  width: '6rem',
                  borderRadius: '4px'
                }}
              ></div>
              <div 
                className="skeleton-badge" 
                style={{ 
                  height: '2rem', 
                  width: '5rem',
                  borderRadius: '4px'
                }}
              ></div>
              <div 
                className="skeleton-badge" 
                style={{ 
                  height: '2rem', 
                  width: '4rem',
                  borderRadius: '4px'
                }}
              ></div>
            </div>
          </div>

          {/* 給与情報のスケルトン */}
          <div className="mb-4">
            <div 
              className="skeleton-line" 
              style={{ 
                height: '3rem', 
                width: '100%', 
                marginBottom: '1rem',
                borderRadius: '8px'
              }}
            ></div>
          </div>

          {/* スキル・職種セクションのスケルトン */}
          <div className="mb-4">
            <div 
              className="skeleton-line" 
              style={{ 
                height: '1.5rem', 
                width: '100%', 
                marginBottom: '1rem',
                borderRadius: '4px'
              }}
            ></div>
            <div className="d-flex flex-wrap gap-2 mb-3">
              <div 
                className="skeleton-badge" 
                style={{ 
                  height: '1.8rem', 
                  width: '4rem',
                  borderRadius: '4px'
                }}
              ></div>
              <div 
                className="skeleton-badge" 
                style={{ 
                  height: '1.8rem', 
                  width: '5rem',
                  borderRadius: '4px'
                }}
              ></div>
              <div 
                className="skeleton-badge" 
                style={{ 
                  height: '1.8rem', 
                  width: '3.5rem',
                  borderRadius: '4px'
                }}
              ></div>
              <div 
                className="skeleton-badge" 
                style={{ 
                  height: '1.8rem', 
                  width: '4.5rem',
                  borderRadius: '4px'
                }}
              ></div>
            </div>
          </div>

          {/* 職種セクションのスケルトン */}
          <div className="mb-4">
            <div 
              className="skeleton-line" 
              style={{ 
                height: '1.5rem', 
                width: '100%', 
                marginBottom: '1rem',
                borderRadius: '4px'
              }}
            ></div>
            <div className="d-flex flex-wrap gap-2 mb-3">
              <div 
                className="skeleton-badge" 
                style={{ 
                  height: '1.8rem', 
                  width: '5rem',
                  borderRadius: '4px'
                }}
              ></div>
              <div 
                className="skeleton-badge" 
                style={{ 
                  height: '1.8rem', 
                  width: '4rem',
                  borderRadius: '4px'
                }}
              ></div>
            </div>
          </div>

          {/* 詳細情報テーブルのスケルトン */}
          <div className="mb-4">
            <div 
              className="skeleton-line" 
              style={{ 
                height: '1.5rem', 
                width: '100%', 
                marginBottom: '1rem',
                borderRadius: '4px'
              }}
            ></div>
            <div className="table-responsive">
              <table className="table table-bordered">
                <tbody>
                  {Array.from({ length: 6 }).map((_, index) => (
                    <tr key={index}>
                      <td style={{ width: '30%' }}>
                        <div 
                          className="skeleton-line" 
                          style={{ 
                            height: '1rem', 
                            width: '80%',
                            borderRadius: '4px'
                          }}
                        ></div>
                      </td>
                      <td>
                        <div 
                          className="skeleton-line" 
                          style={{ 
                            height: '1rem', 
                            width: '60%',
                            borderRadius: '4px'
                          }}
                        ></div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* 説明文のスケルトン */}
          <div className="mb-4">
            <div 
              className="skeleton-line" 
              style={{ 
                height: '1.5rem', 
                width: '100%', 
                marginBottom: '1rem',
                borderRadius: '4px'
              }}
            ></div>
            <div className="mb-2">
              <div 
                className="skeleton-line" 
                style={{ 
                  height: '1rem', 
                  width: '100%', 
                  marginBottom: '0.5rem',
                  borderRadius: '4px'
                }}
              ></div>
              <div 
                className="skeleton-line" 
                style={{ 
                  height: '1rem', 
                  width: '100%', 
                  marginBottom: '0.5rem',
                  borderRadius: '4px'
                }}
              ></div>
              <div 
                className="skeleton-line" 
                style={{ 
                  height: '1rem', 
                  width: '100%', 
                  marginBottom: '0.5rem',
                  borderRadius: '4px'
                }}
              ></div>
              <div 
                className="skeleton-line" 
                style={{ 
                  height: '1rem', 
                  width: '75%', 
                  marginBottom: '0.5rem',
                  borderRadius: '4px'
                }}
              ></div>
            </div>
          </div>

          {/* ボタン部分のスケルトン */}
          <div className="d-flex gap-3">
            <div 
              className="skeleton-line" 
              style={{ 
                height: '3rem', 
                width: '8rem',
                borderRadius: '8px'
              }}
            ></div>
            <div 
              className="skeleton-line" 
              style={{ 
                height: '3rem', 
                width: '6rem',
                borderRadius: '8px'
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobDetailPanelSkeleton;
